// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"736":"bfbac9c0","2752":"a728c4d6","3755":"8bcdcb05","6962":"3baa1acf","8773":"72ca100b"}[chunkId] + ".chunk.css";
};